import script from "./Popover.vue?vue&type=script&setup=true&lang=ts"
export * from "./Popover.vue?vue&type=script&setup=true&lang=ts"

import "./Popover.vue?vue&type=style&index=0&id=4d63bab4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d63bab4"]])

export default __exports__